var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SATabBarItem } from './item.component';
// TODO: Fix issue requirng this any type...
var TabBarContainer = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      border-bottom: 1px solid " + (theme === null || theme === void 0 ? void 0 : theme.separator.line.color) + ";\n      overflow-x: auto;\n      overflow-y: hidden;\n      position: relative;\n      width: 100%;\n\n      -ms-overflow-style: none;  /* Internet Explorer 10+ */\n      scrollbar-width: none;  /* Firefox */\n      &::-webkit-scrollbar {\n        display: none;  /* Safari and Chrome */\n      }\n    ";
});
// TODO: Fix issue requirng this any type...
var TabBar = styled.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var TabBarItems = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  margin: 0;\n  padding: 0;\n"], ["\n  display: flex;\n  margin: 0;\n  padding: 0;\n"])));
export function SATabBar(_a) {
    var activeIndex = _a.activeIndex, itemLabels = _a.itemLabels, onChange = _a.onChange, rest = __rest(_a, ["activeIndex", "itemLabels", "onChange"]);
    return (React.createElement(TabBarContainer, __assign({}, rest),
        React.createElement(TabBar, null,
            React.createElement(TabBarItems, null, itemLabels.map(function (item, index) {
                var key = "sa-tabbar-item-key-" + index;
                return onChange ? (React.createElement(SATabBarItem, { key: key, label: item, active: activeIndex === index, onClick: function () { return onChange(index); } })) : (React.createElement(SATabBarItem, { key: key, label: item, active: activeIndex === index }));
            })))));
}
SATabBar.defaultProps = {};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=tabbar.component.js.map